import React from 'react';
import { Router } from 'react-router-dom';
import BlendAppLayoutContainer from '../containers/BlendAppLayoutContainer';
import history from '../history';

const BlendAppRouter = () => (
    <Router history={history}>
        <BlendAppLayoutContainer />
    </Router>
);

export default BlendAppRouter;
